import _typeof from "@babel/runtime/helpers/typeof";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.assign.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.exec.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.match.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.split.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.keys.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.index-of.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.define-property.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.to-string.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.replace.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.search.js";
function V(e, a) {
  if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function j(e, a, r) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function q(e, a) {
  return L(e) || Q(e, a) || K(e, a) || B();
}
function L(e) {
  if (Array.isArray(e)) return e;
}
function Q(e, a) {
  var r = e == null ? null : (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var t = [],
      i = !0,
      n = !1,
      d,
      m;
    try {
      for (r = r.call(e); !(i = (d = r.next()).done) && (t.push(d.value), !(a && t.length === a)); i = !0);
    } catch (u) {
      n = !0, m = u;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (n) throw m;
      }
    }
    return t;
  }
}
function K(e, a) {
  if (e) {
    if (typeof e == "string") return E(e, a);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return E(e, a);
  }
}
function E(e, a) {
  (a == null || a > e.length) && (a = e.length);
  for (var r = 0, t = new Array(a); r < a; r++) t[r] = e[r];
  return t;
}
function B() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var M = {
    group: /meituangroup/,
    waimai: /meituanwaimai-c|takeoutnew/,
    waimaiB: /meituanwaimai(-b|business)/,
    "dianping-nova": /com\.dianping\./,
    meituanyouxuan_app: /meituanyouxuan_app/,
    conch: /conch/,
    movie: /movie/,
    QCSC: /qcsc\/com\.meituan/,
    weibo: /weibo/,
    weixin: /micromessenger/,
    mqq: /qq\//,
    alipay: /alipayclient/,
    daxiang: / xm\//,
    saori: /saori/,
    moma: /moma/,
    retail: /iretail|retail\.c/,
    zhenguo: /phoenix/,
    mtmaicai: /com\.(baobaoaichi\.imaicai|meituan\.(imaicai\.ep|retail\.v\.android|retail\.v\.android))/,
    groupTurbo: /MeituanTurbo/
  },
  D = {
    10: "group",
    1: "dianping-nova",
    11: "waimai"
  };
function z(e, a) {
  for (var r = Object.keys(M), t = navigator.userAgent.toLowerCase(), i = 0, n = r.length; i < n; i++) if (M[r[i]].test(t)) return r[i];
  if (/openharmony/i.test(t)) {
    var d = /AppId\/(\d+)\/([\d.]+)/,
      m = t.match(d),
      u = /KNB\//i.test(t) && /MSI\//i.test(t);
    if (!u) return "unknown-harmony-app";
    if (m && u) return D[m[1]];
  }
  if (e) {
    var w = e.indexOf("A") + 1,
      c = e.indexOf("B");
    return c = c === -1 ? e.length : c, e.substring(w, c);
  }
  return /titansx/.test(t) ? "unknown-app" : "web";
}
function P(e) {
  var a = {
    exports: {}
  };
  return e(a, a.exports), a.exports;
}
var J = P(function (e, a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.getSystem = void 0;
    function r() {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) > "u") return "node";
      var t = navigator.userAgent.toLowerCase();
      return /android/.test(t) ? "android" : /ios|iphone|ipod|ipad/.test(t) ? "ios" : /macintosh/.test(t) ? "mac" : /windows/.test(t) ? "windows" : "unknown";
    }
    a.getSystem = r;
  }),
  F = P(function (e, a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.decode = void 0;
    function r(t) {
      try {
        return decodeURIComponent(t);
      } catch (_unused) {
        return;
      }
    }
    a.decode = r;
  }),
  H = F,
  O = P(function (e, a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.getAllQueryString = void 0;
    function r() {
      for (var t = location.search.substr(1).split("&"), i = {}, n = 0, d = t.length; n < d; n++) {
        var m = t[n].split("="),
          u = m.shift();
        i[u] = H.decode(m.join("="));
      }
      return i;
    }
    a.getAllQueryString = r;
  }),
  G = P(function (e, a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.getUA = void 0;
    function r() {
      var t = (navigator.userAgent + "").toLowerCase(),
        i = "([0-9][0-9.a-zA-Z_]*)",
        n = function n(s) {
          return new RegExp(s, "i");
        },
        d = function d(s) {
          return typeof s == "string";
        },
        m = location.href,
        u = O.getAllQueryString(),
        w = {
          dianping: [/com\.dianping\.ba.\w+/, /com\.dianping\.\w+/],
          meituan: ["meituangroup", /com.meituan.imeituan-?\w+/],
          maoyanpro: ["moviepro", "moviepro/android"],
          maoyan: ["movie"],
          moma: ["moma"],
          daxiang: ["xm"],
          wechat: ["micromessenger"],
          qq: ["qq"],
          unknown: ["never_match_anything"]
        },
        c = function () {
          for (var o = Object.keys(w), s = 0; s < o.length; s++) for (var h = w[o[s]], v = 0; v < h.length; v++) if (d(h[v]) ? n("\\W" + h[v] + "\\W").test(t) : h[v].test(t)) return o[s];
          return "unknown";
        }(),
        _ = function () {
          for (var o = w[c], s = 0; s < o.length; s++) {
            var h = d(o[s]) ? o[s] : o[s].source,
              v = t.match(n(h + " " + i)) || t.match(n(h + "/" + i));
            if (v) return v[1];
          }
          return "0";
        }(),
        p = function () {
          return /android/.test(t) ? "android" : /ios|iphone|ipod|ipad/.test(t) ? "ios" : /macintosh/.test(t) ? "mac" : /windows/.test(t) ? "windows" : "unknown";
        }(),
        I = function () {
          var o;
          return p === "android" && (o = t.match(n("android " + i)) || t.match(n("android/" + i))), p === "ios" && (o = t.match(n(i + " like Mac OS X")) || t.match(n("iOS/" + i))), (o ? o[1] : "0").replace(/_/g, ".");
        }(),
        N = n("(KNB)/" + i + " (\\w+)/" + i + " (\\w+)/" + i),
        b = n("(KNB)/" + i + " (\\w+)/" + i + " ([a-z1-9A-Z_.-]+/[a-z1-9A-Z_.-]+)/" + i),
        g = t.match(N) || t.match(b),
        k = g && g[2];
      c === "unknown" && g && (c = g[5], _ = g[6]), c === "unknown" && (m.indexOf("wm_ctype=") > -1 && (c = "waimai"), /iphone|ipod|ipad|android/.test(m) && ((u.utm_campaign || "").indexOf("Agroup") > -1 && (c = "meituan"), _ = u.version_name));
      var A = t.match(n("(TitansX|TitansNoX)/" + i)),
        S = A && A[2];
      return {
        appName: c,
        appVersion: _,
        osName: p,
        osVersion: I,
        titansxVersion: S,
        _knbVersion: k
      };
    }
    a.getUA = r;
  }),
  Z = P(function (e, a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.getAllCookie = void 0;
    function r() {
      for (var t = document.cookie.split("; "), i = {}, n = 0, d = t.length; n < d; n++) {
        var m = t[n].split("="),
          u = m.shift();
        i[u] = H.decode(m.join("="));
      }
      return i;
    }
    a.getAllCookie = r;
  }),
  f;
(function (e) {
  e[e.Prod = 0] = "Prod", e[e.Staging = 1] = "Staging", e[e.Test = 2] = "Test", e[e.Dev = 3] = "Dev", e[e.Local = 4] = "Local";
})(f || (f = {}));
var Y = /* @__PURE__ */j(function e() {
    var a = this;
    V(this, e), this.uaInNavigator = navigator.userAgent.toLocaleLowerCase() || window.navigator.userAgent.toLocaleLowerCase() || "", this.isNative = /titans(no)?x/i.test(this.uaInNavigator), this.isHarmony = /openharmony/.test(this.uaInNavigator);
    var r = Z.getAllCookie(),
      t = O.getAllQueryString();
    this.queryStrings = O.getAllQueryString(), /\.dev\.sankuai\.com/.test(location.host) ? (this.runtime = f.Dev, this.pgyEnv = "test") : /\.test\.sankuai\.com/.test(location.host) ? (this.runtime = f.Test, this.pgyEnv = "test") : /\.st\.(sankuai|meituan)\.com/.test(location.host) || t.fixedEnv === "st" ? (this.runtime = f.Staging, this.pgyEnv = "st") : /\.meituan\.com/.test(location.host) ? (this.runtime = f.Prod, this.pgyEnv = "prod") : (this.runtime = f.Local, this.pgyEnv = "test"), this.ecnyHomeUrl = "https://ecny.meituan.com/ecny/home/index.html", this.runtime === f.Staging && (this.ecnyHomeUrl = "http://stable.pay.st.sankuai.com/ecny/home/index.html"), this.runtime === f.Test && (this.ecnyHomeUrl = "http://stable.pay.test.sankuai.com/ecny/home/index.html"), this.runtime === f.Prod && (this.ecnyHomeUrl = "https://ecny.meituan.com/ecny/home/index.html");
    var i = function i() {
      for (var l = 0, x = arguments.length; l < x; l++) {
        var W = l < 0 || arguments.length <= l ? void 0 : arguments[l],
          C = r[W] || t[W];
        if (C) return C;
      }
      return "";
    };
    this.entry = t.entry, this.fupAppType = t.fupAppType, this.layerType = t.layerType, this.businessParams = {
      actName: t.actName,
      actId: t.actId,
      actGroupName: t.actGroupName,
      routerPath: t.routerPath,
      from: t.from || t.utm_source,
      theme: t.theme,
      payType: t.payType,
      institutionId: t.institutionId,
      tokenTime: t.tokenTime,
      activityId: t.activityId,
      scene: t.scene,
      Swimlane: t.Swimlane
    }, this.system = J.getSystem(), this.isIOS = this.system === "ios", this.isAndroid = this.system === "android" || this.isHarmony;
    var n = G.getUA(),
      d = n.osVersion,
      m = n.appVersion;
    this.osVersion = d, this.appName = z(t.utm_campaign);
    var u = navigator.userAgent.toLowerCase();
    if (/micromessenger/i.test(u)) if (/miniprogram/i.test(u)) {
      var w = t.ctype,
        c = t.mina_name;
      w === "wm_wxapp" ? this.appName = "WXAPP_WM" : c === "mt-weapp" ? this.appName = "WXAPP_MT" : this.appName = "WXAPP_UNKNOW";
    } else this.appName = "WXH5";
    if (/dcepclient/i.test(u) && (this.isInDcep = !0, this.appName = "dcep"), /bocapp/i.test(u) && (this.isInBoc = !0, this.appName = "boc"), this.isInConch = this.appName === "conch", this.isInWaimai = this.appName === "waimai", this.isInMeituan = this.appName === "group", this.isInDianping = this.appName === "dianping-nova", this.isInDaxiang = this.appName === "daxiang", this.isInMaicai = this.appName === "mtmaicai", this.isInWXH5 = this.appName === "WXH5", this.isEhcModal = t.ehcShowModal === "true", this.isInWXAPP = !1, (this.appName === "WXAPP_WM" || this.appName === "WXAPP_MT" || this.appName === "WXAPP_UNKNOW") && (this.isInWXAPP = !0), this.commonParams = {
      entry: this.entry,
      cityId: i("ci", "cityid") || 0,
      token: i("token", "mt_c_token", "oops", "thirdlogin_token"),
      ci: i("ci"),
      uuid: i("iuuid", "uuid", "dpid"),
      app: this.appName,
      version: i("version_name", "wm_appversion") || m,
      platform: this.isInWXAPP ? "weixin" : this.system,
      location: "",
      wx_openid: this.isInWXAPP ? i("openId", "openid") : "",
      wx_expoId: this.isInWXAPP ? i("openIdCipher") : ""
    }, this.appName === "WXAPP_MT") this.commonParams.wx_appid = "wxde8ac0a21135c07d";else if (this.appName === "WXAPP_WM") {
      this.commonParams.wx_appid = "wx2c348cf579062e56";
      try {
        var _ = JSON.parse(decodeURIComponent(i("wx_pay_params"))) || {};
        this.commonParams.wx_expoId = _.openIdCipher;
      } catch (y) {
        var p = window.Owl;
        p && p.addError && p.addError({
          name: "外卖小程序获取openIdCipher失败",
          msg: JSON.stringify(y)
        }, {
          level: "error"
        });
      }
    } else if (this.isHarmony) {
      var I = /KNB\//.test(this.uaInNavigator) && /MSI\//.test(this.uaInNavigator);
      if (I) {
        var N = this.uaInNavigator.match(/AppId\/(\d+)\/([\d.]+)/),
          b = N ? N[1] : "";
        this.commonParams.version = b || "";
        var g = this.uaInNavigator.match(/OpenHarmony\s([\d.]+)/),
          k = g ? g[1] : "";
        this.osVersion = k;
      }
      this.appName = "harmony", this.commonParams.platform = "harmony";
    }
    if (window.H5guard) try {
      this.commonParams.wx_h5_fingerprint = window.H5guard.getfp();
    } catch (y) {
      var p = window.Owl;
      p && p.addError && p.addError({
        name: "H5guard.getfp()获取指纹信息失败",
        msg: JSON.stringify(y)
      }, {
        level: "error"
      });
    }
    try {
      if (!this.isNative) return;
      window.KNB.ready(function () {
        window.KNB.getFingerprint({
          success: function success(l) {
            var x = l.fingerprint;
            a.commonParams.fingerprint = x || "";
          },
          fail: function fail() {
            var l = window.Owl;
            l && l.addError && l.addError({
              name: "getFingerprint获取指纹信息失败",
              msg: ""
            }, {
              level: "warn"
            });
          }
        });
      });
    } catch (y) {
      var p = window.Owl;
      p && p.addError && p.addError({
        name: "getFingerprint获取指纹信息失败",
        msg: JSON.stringify(y)
      }, {
        level: "warn"
      });
    }
    var A = (i("latlon") || "").split(",");
    if (A.length === 1) {
      var S = i("lat") || i("wm_actual_latitude") || i("wm_latitude") || 0,
        o = i("lng") || i("wm_actual_longitude") || i("wm_longitude") || 0;
      this.commonParams.location = "".concat(S, "_").concat(o);
    } else {
      var s = q(A, 2),
        h = s[0],
        v = h === void 0 ? "0" : h,
        T = s[1],
        U = T === void 0 ? "0" : T;
      this.commonParams.location = "".concat(v || 0, "_").concat(U);
    }
  }),
  X = new Y(),
  pt = Object.assign(X, Object.assign({}, X.businessParams));
export { pt as default };
